import React, { useEffect, useState } from "react";
import TreeViewNavbar from "../../components/Tree/TreeViewNavbar";
import TreeViewContent from "../../components/Tree/tree-view/TreeViewContent";
import { useSelector } from "react-redux";
import { getUserDefaultPlan } from "../../utils/defaultPlan";

const TreeView = () => {
  const [treePlan, setTreePlan] = useState(null);
  const userPlans = useSelector((state) => {
    return state.dashboard?.appLayout?.userplans;
  });
  const userDefaultPlan = getUserDefaultPlan();

  useEffect(() => {
    if (userDefaultPlan) {
      setTreePlan(userDefaultPlan);
    } else if (userPlans?.defaultPlan) {
      setTreePlan(userPlans.defaultPlan);
    }
  }, [userPlans, userDefaultPlan]);

  return (
    <>
      {treePlan &&
        <>
          <TreeViewNavbar menu={"treeView"} treePlan={treePlan} setTreePlan={setTreePlan} />
          <TreeViewContent
            treePlan={treePlan}
          />
        </>
      }
    </>
  );
};

export default TreeView;
